@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/index-cards-3x5/koan-index-card-stack-content/koan-index-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  padding: 0.5rem;
  box-sizing: border-box;
}
:host .main-section {
  display: flex;
  padding: 0.375rem 1.75rem 0.5rem 1.75rem;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  flex: 1 0 0;
  align-self: stretch;
  border: 0.15625rem solid #222222;
}
:host .main-section .top-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}
:host .main-section .top-container .brand-section {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  height: 6.2rem;
}
:host .main-section .top-container .brand-section .brush-stroke {
  width: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: -1;
}
:host .main-section .top-container .brand-section .product-card-image {
  max-width: 4rem;
  max-height: 4rem;
  height: auto;
}
:host .main-section .top-container .brand-section .product-card-brand {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 1.0625rem;
  max-height: 5.2rem;
  text-align: center;
}
:host .main-section .top-container .product-card-name {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.0625rem;
  height: 2.5rem;
  text-align: center;
}
:host .main-section .top-container .properties-container {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 0.6875rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
}
:host .main-section .top-container .properties-container .property-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
}
:host .main-section .top-container .product-card-badge-and-label-container {
  margin-top: 0.25rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: 0.375rem;
  height: 0.875rem;
}
:host .main-section .top-container .product-card-badge-and-label-container .product-card-badge {
  height: 1rem;
  width: 1rem;
}
:host .main-section .top-container .product-card-badge-and-label-container .print-card-label {
  height: fit-content;
  margin: 0;
  padding: 0;
}
:host .main-section .top-container .product-card-badge-and-label-container .print-card-label ::ng-deep .product-label {
  font-family: rubik, sans-serif;
  font-weight: 500;
  font-size: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.125rem;
  padding: 0.1875rem 0.1875rem 0.0625rem;
  width: fit-content;
}
:host .main-section .top-container .product-card-description {
  margin-top: 0.25rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
}
:host .main-section .top-container .product-card-description ::ng-deep .description-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}
:host .main-section .top-container .product-card-description ::ng-deep .description-container .plain-text {
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
}
:host .main-section .top-container .product-card-description ::ng-deep .description-container .rich-text {
  max-height: 8.4rem;
  overflow-y: hidden;
}
:host .main-section .top-container .product-card-description.description-text-6-lines ::ng-deep .description-container .plain-text {
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
}
:host .main-section .top-container .product-card-description.description-text-6-lines ::ng-deep .description-container .rich-text {
  max-height: 7.4rem;
}
:host .main-section .top-container .product-card-description.description-text-8-lines ::ng-deep .description-container .plain-text {
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
}
:host .main-section .top-container .product-card-description.description-text-8-lines ::ng-deep .description-container .rich-text {
  max-height: 9.4rem;
}
:host .main-section .top-container .product-card-description.description-text-9-lines ::ng-deep .description-container .plain-text {
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
}
:host .main-section .top-container .product-card-description.description-text-9-lines ::ng-deep .description-container .rich-text {
  max-height: 10.4rem;
}
:host .main-section .bottom-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 0.8125rem;
}
:host .main-section .bottom-container .terpenes-container {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 0.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
:host .main-section .bottom-container .terpenes-container .total-terpene-container {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
}
:host .main-section .bottom-container .price-and-size-container {
  display: grid;
  max-width: 100%;
}
:host .main-section .bottom-container .price-and-size-container .product-card-price-container {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
}
:host .main-section .bottom-container .price-and-size-container .product-card-price-container ::ng-deep .product-variant-price {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 0.5rem;
}
:host .main-section .bottom-container .price-and-size-container .product-card-price-container ::ng-deep .product-variant-price .product-variant-previous-price {
  font-size: 0.75rem;
}
:host .main-section .bottom-container .price-and-size-container .product-card-price-container ::ng-deep .product-variant-price .product-variant-previous-price .product-variant-price-decoration {
  font-size: 0.75rem;
}
:host .main-section .bottom-container .price-and-size-container .product-card-price-container ::ng-deep .product-variant-price .product-variant-current-price {
  font-size: 1.125rem;
}
:host .main-section .bottom-container .price-and-size-container .product-card-size {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
}
/*# sourceMappingURL=koan-index-card-stack-content.component.css.map */
